import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { Image } from '../../../components/Image';
import styles from './TechProductCard.module.scss';
import { BreakPoint, useScreenSize } from '../../../components/ScreenSize';
import { ProductCardItem } from '../type';

/**
 * 技术产品卡片组件
 * 用于展示无人机、自动车等技术产品的详细信息
 * 支持通过数据动态展示不同的产品内容
 */
const TechProductCard: FC<ProductCardItem> = (props) => {
  const { titleArr, intro, bgImg, imageConfig = {}, dataGroups, dataTime, className = '' } = props;

  const { width = 848, height = 445, right, left, top, bottom, showWidthPC, showWidthH5 } = imageConfig;
  const { screen } = useScreenSize();

  const isMobile = screen === BreakPoint.sm || screen === BreakPoint.md;
  // 构建图片容器的动态样式
  const imageStyle: React.CSSProperties = useMemo(() => {
    if (isMobile) {
      return showWidthH5 ? { maxWidth: showWidthH5 } : {};
    }

    return {
      ...(right && { right }),
      ...(left && { left }),
      ...(top && { top }),
      ...(bottom && { bottom }),
      ...(showWidthPC && { maxWidth: showWidthPC }),
    };
  }, [isMobile, right, left, top, bottom, showWidthPC, showWidthH5]);

  return (
    <div className={classNames(styles['tech-product-card'], className)}>
      <div className={classNames(styles['card-wrapper'], styles['card-content-wrapper'])}>
        {/* 产品标题和介绍 */}
        <div className={styles['card-content-main']}>
          <div className={styles['card-title']}>
            {titleArr.map((title) => (
              <div key={title}>{title}</div>
            ))}
          </div>

          {/* 产品介绍信息 */}
          <div className={styles['card-intro']}>{intro}</div>

          {/* 数据组循环展示 */}
          {dataGroups.map((group, groupIndex) => (
            <React.Fragment key={`group-${groupIndex}`}>
              <div className={styles['card-data-box']}>
                {group.items.map((item, itemIndex) => (
                  <React.Fragment key={`item-${groupIndex}-${itemIndex}`}>
                    {itemIndex > 0 && <div className={styles['data-divide-line']} />}
                    {item.label && <div className={styles['data-label-left']}>{item.label}</div>}
                    <div className={classNames('mt-font', styles['data-value'])}>
                      <span className={styles['value-quantity']}>{item.value}</span>
                    </div>
                    {item.unit && <div className={styles['data-label-right']}>{item.unit}</div>}
                  </React.Fragment>
                ))}
              </div>
              <div className={styles['card-intro-sm']}>{group.intro}</div>
            </React.Fragment>
          ))}
        </div>

        <p className={styles['card-intro-time']}>{dataTime}</p>

        {/* 产品图片 */}
        <div className={styles['card-image']} style={imageStyle}>
          <Image src={bgImg} width={width} height={height} layout="responsive" />
        </div>
      </div>
    </div>
  );
};

TechProductCard.displayName = 'TechProductCard';
export default TechProductCard;
